<template>
  <v-btn
    fixed
    bottom
    :right="!_includes(['xs', 'sm'], $mq)"
    large
    v-on="$listeners"
    :loading="getSaving > 0"
    :disabled="getSaving > 0"
    :class="['publish-btn white--text', $mq]"
    color="orange darken-3"
    >{{
      _includes(['xs', 'sm', 'md'], $mq) ? 'Publish' : 'Publish Changes'
    }}</v-btn
  >
</template>

<script>
import { mapGetters } from 'vuex'
import _includes from 'lodash/includes'
export default {
  name: 'AdminButtonPublishChanges',
  components: {},
  data() {
    return {}
  },
  computed: { ...mapGetters('admin', ['getSaving']) },
  methods: {
    _includes,
  },
}
</script>

<style lang="scss">
.publish-btn {
  &.v-btn--bottom {
    bottom: 20px;
  }
  &.v-btn--right {
    right: 280px;
  }
  &.xs,
  &.sm,
  &.md {
    right: 20px;
  }
}
</style>
